import React, { useState, useEffect, useRef } from 'react'
import Header from '../general/Header'
import SubHeader from '../general/SubHeader';
import BottomBanner from '../general/BottomBanner';
import extraImg from '../assets/empty-cart.gif';
import ResponseMsg from '../general/ResponseMsg';
import { useNavigate } from 'react-router-dom';
import SuccessImg from '../assets/order-success.gif';
import Loading from '../general/Loading';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import StaffImg1 from '../assets/staff-img1.gif';


delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const Checkout = ({ isUser, userData }) => {
  const [location, setLocation] = useState(null);
  const [response, setResponse] = useState(null);
  const [cart, setCart] = useState([]);
  const [platformFee, setPlatformFee] = useState('');
  const [deliveryFee, setDeliveryFee] = useState('');
  const [qrCode, setQrCode] = useState('');
  const [payId, setPayId] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [confirmOrder, setConfirmOrder] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [coupon, setCoupon] = useState([]);
  const [showCoupon, setShowCoupon] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [address, setAddress] = useState('');
  const [showMap, setShowMap] = useState(false);
  const [paymentDialog, showPaymentDialog] = useState(false);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    updateCartFromStorage();
    fetchCoupons();
  }, []);


  const fetchCoupons = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcmstore.in/store/get-coupon');

      setLoading(false);
      if (response.ok) {
        const data = await response.json();
        setCoupon(data);
      } else {
        setLoading(false);
        console.error('Failed to fetch staff members');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching staff:', error);
    }
  };

  const updateCartFromStorage = async () => {
    const response = await fetch(`https://api.kcmstore.in/store/get-mycart/${userData.id}`);
    if (response.ok) {
      const data = await response.json();
      console.log(data);
      const sortedProducts = data.sort((a, b) => b.id - a.id);
      setCart(sortedProducts || []);
    } else {
      setCart([]);
    }

  };


  const handleRemoveItem = async (productId) => {
    try {
      const response = await fetch(`https://api.kcmstore.in/store/remove-cart/${productId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await response.json();

      if (response.ok) {
        console.log('✅ Cart synced with backend:', data);


        updateCartFromStorage();

        window.dispatchEvent(new Event('cartUpdated'));
      } else {
        console.error('❌ Failed to sync cart:', data.message || 'Unknown error');
      }
    } catch (error) {
      console.error('⚠️ Network error while syncing cart:', error);
    }
  };



  const handleQuantityChange = async (cartId, prod_name, action) => {
    const existingCart = cart || [];

    let updatedQty = 1;

    const updatedCart = existingCart.map(item => {
      if (item.id == cartId) {
        if (action === 'increment') {
          updatedQty = item.quantity + 1;
        } else {
          updatedQty = item.quantity > 1 ? item.quantity - 1 : 1;
        }

        return { ...item, quantity: updatedQty };
      }
      return item;
    });


    setCart(updatedCart);


    try {
      await fetch(`https://api.kcmstore.in/store/update-quantity/${cartId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userData.id,
          item_qty: updatedQty,
        }),
      });
    } catch (error) {
      console.error('⚠️ Quantity update failed:', error);
    }
  };



  const calculateTotal = () => {
    return cart.reduce((total, product) => total + parseFloat(product.sell_price) * product.quantity, 0).toFixed(2);
  };

  const calculateDiscount = () => {
    if (!selectedCoupon || !selectedCoupon.id) return 0;

    const total = Number(calculateTotal());

    if (selectedCoupon.discount_type === "amount") {
      return Number(selectedCoupon.discount_amount);
    }

    if (selectedCoupon.discount_type === "percent") {
      return (total * Number(selectedCoupon.discount_amount)) / 100;
    }

    return 0;
  };

  const calculateGrandTotal = () => {
    const totalAmt = calculateTotal();
    const discount = calculateDiscount();
    return ((Number(totalAmt) + Number(platformFee) + Number(deliveryFee)) - discount);
  }

  const calculateTotalItem = () => {
    return cart.reduce((total, product) => total + product.quantity, 0);
  };

  const total = calculateTotal();

    useEffect(() => {
  if (
    selectedCoupon &&
    Number(total) < Number(selectedCoupon.order_value)
  ) {
    setSelectedCoupon(null);
     setResponse("Coupon removed: Minimum Order value is Low");
    setTimeout(() => setResponse(''), 2000);
  }
}, [total, selectedCoupon]);

  // const resetCart = () => {
  //     setCart([]);
  //     localStorage.removeItem('cart');
  // };
  const resetCart = async () => {
    try {
      await fetch(`https://api.kcmstore.in/store/clear-cart/${userData.id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      });
    } catch (err) {
      console.error("⚠️ Failed to clear backend cart:", err);
    }

    // Clear frontend cart
    setCart([]);
    window.dispatchEvent(new Event('cartUpdated'));
  };


  const handlePlaceOrder = async (pay_mode) => {
    if (!isUser) {
      setResponse("Please log in to place an order.");
        setTimeout(() => {
          setResponse('');
        }, 2000);      return;
    }


    if (pay_mode == 'Online' && payId == '') {
      setResponse("Enter payment Id for Online Payment Order");
        setTimeout(() => {
          setResponse('');
        }, 2000);      return;
    }


    // console.log(location);
    setLoading(true);
    // console.log(cart);

    const orderDetails = cart.map(product => ({
      product_name: product.name,
      quantity: product.quantity,
      product_price: product.sell_price,
      org_price: product.org_price,
      discount_type: product.discount_type,
      discount_amount: product.discount_amount,
      image: product.image,
      // subadmin_id: product.subadmin_id,
      // subadmin_name: product.subadmin_name,
    }));

    // Construct the order object
    const orderData = {
      order_items: orderDetails,
      total_price: calculateGrandTotal(),
      payment_mode: pay_mode,
      payment_id: payId || '',
      payment_status: pay_mode == 'Online' ? 'completed' : 'pending',
      user_id: userData.id,
      latitude: location?.latitude || '',
      longitude: location?.longitude || '',
      platform_fee: platformFee,
      delivery_charge: deliveryFee,
      coupon_applied: JSON.stringify(selectedCoupon),      
    };

    try {
      const response = await fetch('https://api.kcmstore.in/store/place-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(orderData),
      });
      const result = await response.json();
      setLoading(false);

      if (response.ok) {
        showPaymentDialog(false);
        setConfirmOrder(false);
        setShowSuccess(true);
        setTimeout(() => {
          resetCart();
          navigate('/');
        }, 5000);
      } else {
        setResponse('Cannot place order. Please try again.');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    };
  };


  const handleOnlineOrder = async () => {
    if (!isUser) {
      setResponse("Please log in to place an order.");
      return;
    }

    
  }


  const getCurrentLoc = async () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }

    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        setLocation({ latitude, longitude });
        setShowMap(true);
        setLoading(false);
      },
      (err) => {
        console.error("Geolocation error:", err);
        setLoading(false);
        setShowMap(true);
      }
    );
  };


  const getFeeData = async () => {
    setLoading(true);

    try {
      const response = await fetch(`https://api.kcmstore.in/store/get-fee`);
      setLoading(false);
      if (response.ok) {
        const data = await response.json();
          setPlatformFee(data.platform_fee);
        setDeliveryFee(data.delivery_fee);
        setQrCode(data.qr_code);
      } else {
        console.error('Failed to fetch prescription');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching prescription:', error);
    }
  }


  useEffect(() => {
    // getCurrentLoc();
    getFeeData();
  }, []);



  useEffect(() => {
    if (showMap) {
      // 🧹 Clear any old map before re-creating
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }

      const map = L.map("map", {
        center: [location?.latitude || 20.5937, location?.longitude || 78.9629],
        zoom: 13,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "© OpenStreetMap contributors",
      }).addTo(map);

      const marker = L.marker(
        [location?.latitude || 20.5937, location?.longitude || 78.9629],
        { draggable: true }
      ).addTo(map);

      markerRef.current = marker;
      mapRef.current = map;

      marker.on("dragend", async () => {
        const pos = marker.getLatLng();
        const newLoc = { latitude: pos.lat, longitude: pos.lng };
        setLocation(newLoc);
        await fetchAddress(newLoc);
      });

      fetchAddress({
        latitude: location?.latitude || 20.5937,
        longitude: location?.longitude || 78.9629,
      });
    }
  }, [showMap]);


  // ✅ Reverse geocode using Nominatim
  const fetchAddress = async ({ latitude, longitude }) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
      );
      const data = await response.json();
      if (data && data.display_name) {
        setAddress(data.display_name);
        setLoading(false);
      } else {
        setAddress("Address not found");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      setLoading(false);
    }
  };


  return (
    <>
      <Header isUser={isUser} userData={userData} />

      <SubHeader message="Check Out" />

      <section className='my-5'>
        <div className='container'>
          <p className='sec-heading'>Shopping Cart</p>


          <div className='row'>

            {cart.length === 0 ? (
              <div className='text-center my-4'>
                <p className='fw-semibold my-0'>No Items added in Cart</p>
                <img src={extraImg} className='img-fluid' style={{ height: '16em' }} alt='empty cart' />
              </div>
            ) : (
              <>
                <div className='col-lg-8'>
                  {cart.map((product) => (
                    <div className='cart-item' key={product.medicine_id}>
                      <div className='row text-start align-items-center'>

                        <img src={`https://api.kcmstore.in/sUploads/${product.image.split(',')[0]}`} className='col-md-2 col-sm-2 col-4' alt={product.name} />

                        <p className='col-md-3 col-sm-4 col-4'><span className='featured-name cursor-pointer' onClick={() => navigate(`/medicine-details/${product.name}`, { state: { product } })}>{product.name}</span>
                          <br /><span className='featured-category'>{product.unit}</span></p>
                        <p className='col-md-2 col-sm-2 col-4 featured-price'>
                          ₹ {(product.sell_price * product.quantity).toFixed(2)}
                        </p>
                        <p className='col-md-2 col-sm-2 col-4 action-btn-area my-2'>
                          <span className='action-btn' onClick={() => handleQuantityChange(product.id, product.name, 'decrement')}>-</span>
                          <span className='px-2'>{product.quantity}</span>
                          <span className='action-btn' onClick={() => handleQuantityChange(product.id, product.name, 'increment')}>+</span></p>

                        <span className='text-secondary col-md-3 col-sm-2 col-4 text-center fs-3 cursor-pointer' onClick={() => handleRemoveItem(product.id)}><i class="fa-solid fa-delete-left"></i></span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className='col-lg-4 mt-3'>
                  <p className='fs-6 coupon-code px-3 py-2 cursor-pointer' onClick={() => setShowCoupon(true)}>Available Coupons</p>
                  <div className='bg-light px-3 py-3 rounded-3'>

                    <p className='fw-bold fs-5'>Summary</p>
                    <div className='d-flex mb-2 justify-content-between'><span>Total Items:</span><span>{calculateTotalItem()}</span> </div>
                    <div className='d-flex mb-2 justify-content-between'><span>Order Total:</span><span>₹{calculateTotal()}</span> </div>
                    <div className='d-flex mb-2 justify-content-between'><span>Platform Fee:</span><span>₹{platformFee}</span> </div>
                    <div className='d-flex mb-2 justify-content-between'><span>Delivery Charges: </span><span>₹{deliveryFee}</span> </div>
                    <div className='d-flex mb-2 justify-content-between'><span>Sub Total: </span><span>₹{calculateGrandTotal() + calculateDiscount()}</span> </div>

                    {selectedCoupon != null &&
                      <div className='d-flex justify-content-between border-top'>

                        <span>Coupon Applied:<br />({selectedCoupon.coupon_code}) </span><span>- {selectedCoupon.discount_type == 'amount' && '₹'}{selectedCoupon.discount_amount}{selectedCoupon.discount_type == 'percent' && '%'} OFF</span> </div>}
                    <div className='d-flex my-2 py-2 border-top border-bottom justify-content-between fw-bold'><span>Grand Total:</span><span>₹{calculateGrandTotal().toFixed(2)}</span> </div>


                    <div>
                      <div className="border-bottom my-4 py-2 text-darkblue">
                        <p className="fw-bold my-0 cursor-pointer" onClick={getCurrentLoc}>
                          {loading ? "Getting location..." : "Select Delivery Location"}{" "}
                          <i className="fa-solid fa-location-crosshairs"></i>
                        </p>
                        {address && (
                          <p className="para-text fw-semibold text-success">
                            📍 {address}
                          </p>
                        )}
                      </div>

                      {showMap && (
                        <div className="map-modal">
                          <div
                            id="map"
                            style={{ width: "100%", height: "350px", borderRadius: "8px" }}
                          ></div>
                          <button
                            className='sort-btn py-2 px-3 my-2'
                            onClick={() => setShowMap(false)}
                          >
                            Confirm Location
                          </button>
                        </div>
                      )}
                    </div>


                    <button
                      className='sort-btn py-2 px-3 mb-2'
                      onClick={() => {

                        if (location == null) {
                          setResponse('Select Delivery Location to Place Order.');
                          setTimeout(() => {
                            setResponse('');
                          }, 2000);
                          return;
                        }


                        else {
                          setConfirmOrder(true);
                        }
                      }}
                    >
                      Cash On Delivery
                    </button>
                    &nbsp;&nbsp;
                    <button className='sort-btn py-2 px-3' onClick={() => {if (location == null) {
                          setResponse('Select Delivery Location to Place Order.');
                          setTimeout(() => {
                            setResponse('');
                          }, 2000);
                          return;
                        }


                        else {
                          showPaymentDialog(true)
                        }}}>Proceed to Pay</button>

                  </div>
                </div>


              </>
            )}


          </div>
          {/* row ends */}

        </div>
      </section>

      <BottomBanner />

      {showSuccess && (
        <section className='login-dialog px-3 py-3'>
          <div className='mx-auto py-3 px-3 bg-white text-center animate__animated animate__zoomIn'>
            <span className='cursor-pointer float-end' onClick={() => setShowSuccess(false)}><i class="fa-solid fa-xmark"></i></span>
            <img src={SuccessImg} className='img-fluid' />
            <p className='cart-heading'>Order Placed Successfully!</p>
            <p className='text-muted fw-semibold'>Your order will be delivered soon. Thanks for choosing KCM Store.</p>
          </div>
        </section>
      )}


            {paymentDialog && (
        <section className='delete-dialog px-3 py-5'>
          <div className='bg-white col-md-8 mx-auto px-3 py-4 rounded-4 text-center'>

            <div className='d-flex justify-content-between'>
            <p className='sec-heading fs-4 text-center'>Pay online</p>
            <span className='fs-5 cursor-pointer' onClick={() => showPaymentDialog(false)}><i className="fa-solid fa-xmark"></i></span>
            </div>

<p className='text-start fw-semibold'>• Scan the QR code using any UPI app<br />
                • Complete the payment<br />
                • Enter UTR/ Payment ID below<br />
                • Click Proceed to confirm order</p>

<img src={`https://api.kcmstore.in/sUploads/${qrCode}`} className='w-auto' style={{ height: '16em'}} />


<div className='d-flex'>
                                    <input
                                        type="text"
                                        className="form-input my-3 me-3"
                                        id="offerName"
                                        placeholder='Enter Payment Id'
                                        value={payId}
onChange={(e) => setPayId(e.target.value)}                                        required
                                    />
              <button className="success-btn text-nowrap my-3" onClick={() => handlePlaceOrder('Online')}>Confirm Order</button>
</div>

</div>
</section>
            )
            }

      {confirmOrder && (
        <section className='delete-dialog px-3 py-5'>
          <div className='bg-white col-md-8 mx-auto px-3 py-4 rounded-4 text-start'>
            <p className='sec-heading fs-4 text-center'>Order Summary</p>

            <div className='invoice-area my-5'>
              <p>Customer Name: {userData.name}<br />
              Mobile No: {userData.phone}<br />
                Delivery Address: {location
                  ? address
                  : `${userData.address || userData.location} ${userData.city} ${userData.state} ${userData.pincode}`}
              </p>

              <div className='table-responsive'>
                <hr />
                <table className='w-100'>
                  <tr>
                    <th className='px-2 py-2'>Product</th>
                    <th className='px-2 py-2'>MRP ₹</th>
                    <th className='px-2 py-2'>Qty</th>
                    <th className='px-2 py-2'>Discount</th>
                    <th className='px-2 py-2'>Total ₹</th>
                    {/* <th className='px-2 py-2'>Seller Details</th> */}
                  </tr>

                  {cart.map((product) => (
                    <tr key={product.medicine_id}>
                      <td className='px-2 py-2'>{product.name}</td>
                      <td className='px-2 py-2'>{product.org_price}</td>
                      <td className='px-2 py-2'>{product.quantity}</td>
                      <td className='px-2 py-2'>{product.discount_type == 'amount' ? '₹' : ''} {product.discount_amount} {product.discount_type == 'percent' ? '%' : ''}</td>
                      <td className='px-2 py-2'>{product.sell_price * product.quantity}</td>
                      {/* <td className='px-2 py-2'>Name: {product.subadmin_name}<br />Address: {product.subadmin_address} {product.subadmin_city} {product.subadmin_state}</td> */}
                    </tr>

                  ))}

                </table>
                <hr />
              </div>
              {/* table area */}

              <p className='para-text fw-semibold my-0'>Total Items: {calculateTotalItem()}</p>
              <p className='mb-1 para-text'>Order Total: ₹{calculateTotal()}<br />Platform Fee: ₹{platformFee}<br />Delivery Charges: ₹{deliveryFee}</p>
              <p className='my-0 py-1 border-top text-end para-text'>Sub Total: ₹{calculateGrandTotal() + calculateDiscount()}
                    {selectedCoupon != null &&
                      <div className='d-flex justify-content-end'>

                        <span>Coupon Applied({selectedCoupon.coupon_code}):&nbsp; </span><span> {selectedCoupon.discount_type == 'amount' && '₹'}{selectedCoupon.discount_amount}{selectedCoupon.discount_type == 'percent' && '%'} OFF</span> </div>}
                
                </p>
              <p className='fw-semibold my-0 py-1 border-top text-end'>Grand Total: ₹{calculateGrandTotal()}</p>

            </div>

            <div className='text-end'>
              <button className='danger-btn' onClick={() => setConfirmOrder(false)}>Cancel</button>&nbsp;&nbsp;
              <button className="success-btn" onClick={() => handlePlaceOrder('Cash On Delivery')}>Confirm Order</button>
            </div>

          </div>
        </section>
      )}


      {showCoupon && (
        <section className='delete-dialog px-3 py-5'>
          <div className='bg-white col-md-8 mx-auto px-3 py-4 rounded-4 text-start'>

            <div className='d-flex justify-content-between'>
              <p className='sec-heading fs-4 text-center'>Select Coupon</p>
              <span className='cursor-pointer' onClick={() => setShowCoupon(false)}><i className="fa-solid fa-xmark fs-4"></i></span>
            </div>


            {coupon.length > 0 ? (
              coupon.map((c) => (
                <div key={c.id} className='staff-area text-start mb-3 d-flex justify-content-between'>
                  <div>
                    <p className='featured-category text-capitalize'>{c.coupon_name}                                              <span className='px-3 py-1 coupon-code' >                        {c.coupon_code}</span>
                    </p>

                    <p className='mt-2 para-text fw-semibold text-muted'>Get upto {c.discount_type == 'amount' && '₹'}{c.discount_amount}{c.discount_type == 'percent' && '%'} OFF. Applicable on Orders with Min. Order Total value ₹{c.order_value}</p>
                  </div>


                  {Number(total) >= Number(c.order_value) && (
                 selectedCoupon?.id != c.id ?
                      <div className='align-content-center'>
                        <button className='btn btn-dark' onClick={() => { setSelectedCoupon(c); setShowCoupon(false) }}>Apply</button>
                      </div>
                      : <div className='align-content-center' onClick={() => { setSelectedCoupon(null); setShowCoupon(false) }}><button className='sort-btn rounded'>Remove</button></div>

                  )}
                </div>
              ))
            ) : (
              <>
                <div className='text-center'>
                  <img src={StaffImg1} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                  <p className='fw-bold'>No Coupon Available yet.</p>
                </div>
              </>
            )}

          </div>
        </section>
      )}

      {response && <ResponseMsg message={response} />}
      {loading && <Loading setLoading={setLoading} />}


    </>
  )
}

export default Checkout
